import { SaveDialogProps } from "designSystem/components/dialog/SaveDialog";
import { SaveDialog } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import PPProductLayout from "./PPProductLayout";
import PPProductLayoutStore from "./PPProductLayoutStore";

interface SetEditDialogProps extends SaveDialogProps {
	/** store containing set data */
	productStore: PPProductLayoutStore;
}

const SetEditDialog: FunctionComponent<SetEditDialogProps> = observer((props) => {
	const { productStore, ...otherProps } = props;
	const { editSetStore } = productStore;

	// NOTE: disableEnforceFocus since Dojo view is inserted

	return (
		<SaveDialog
			confirmClose={editSetStore.hasChanged}
			contentSpacing={0}
			disableEnforceFocus
			disableSave={!editSetStore.hasChanged}
			fullHeight
			fullWidth
			onValidate={async () => editSetStore.validateChanges()}
			titleRes="PPEditSet"
			{...otherProps}
		>
			{{
				main: <PPProductLayout productStore={productStore} />,
			}}
		</SaveDialog>
	);
});

export default SetEditDialog;
